import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

import { Field, Form, Formik } from 'formik';
import getGravatar from 'gravatar';
import React, { useEffect, useRef, useState } from 'react';
import { useOrg } from '../hooks/useOrg';
import { useUser } from '../hooks/useUser';
import { post } from '../lib/api';
import Avatar from './Avatar';

var ForgotPassword = function ForgotPassword(_ref) {
  var setMessage = _ref.setMessage,
      setParentView = _ref.setParentView,
      apiHost = _ref.apiHost;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(false),
      emailSent = _useState2[0],
      setEmailSent = _useState2[1];

  var _useOrg = useOrg(),
      organizationId = _useOrg.organizationId;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var _yield$post, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return post(apiHost, '/api/password/forgot', {
                email: values.email,
                redirect: window.location.href,
                organizationId: organizationId
              });

            case 3:
              _yield$post = _context.sent;
              error = _yield$post.error;

              if (error) {
                setMessage(error.message);
              } else {
                setEmailSent(true);
              }

              setLoading(false);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleReturnToPost = function handleReturnToPost(e) {
    e.preventDefault();
    setParentView('question-form');
  };

  return /*#__PURE__*/React.createElement(Formik, {
    validateOnMount: true,
    initialValues: {
      email: ''
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.email) {
        errors.email = 'Required';
      }

      return errors;
    },
    onSubmit: handleSubmit
  }, function (_ref3) {
    var isValid = _ref3.isValid;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "email"
    }, "Email address"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "email",
      name: "email",
      type: "email",
      placeholder: "Email address..."
    }), emailSent ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Check your email for password reset instructions"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("button", {
      onClick: handleReturnToPost,
      className: "squeak-return-to-post"
    }, "Click here"), ' ', "to return to your post")) : /*#__PURE__*/React.createElement("button", {
      style: loading || !isValid ? {
        opacity: '.5'
      } : {},
      type: "submit"
    }, "Send password reset instructions"));
  });
};

var SignIn = function SignIn(_ref4) {
  var setMessage = _ref4.setMessage,
      handleMessageSubmit = _ref4.handleMessageSubmit,
      formValues = _ref4.formValues,
      apiHost = _ref4.apiHost,
      buttonText = _ref4.buttonText,
      organizationId = _ref4.organizationId;

  var _useState3 = useState(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var _useUser = useUser(),
      setUser = _useUser.setUser;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values) {
      var _yield$post2, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return post(apiHost, '/api/login', {
                email: values.email,
                password: values.password,
                organizationId: organizationId
              });

            case 3:
              _yield$post2 = _context2.sent;
              data = _yield$post2.data;
              error = _yield$post2.error;

              if (!error) {
                _context2.next = 11;
                break;
              }

              setMessage('Incorrect email/password. Please try again.');
              setLoading(false);
              _context2.next = 14;
              break;

            case 11:
              setUser({
                id: data.id
              });
              _context2.next = 14;
              return handleMessageSubmit(formValues || {
                email: values.email
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Formik, {
    validateOnMount: true,
    initialValues: {
      email: '',
      password: ''
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.email) {
        errors.email = 'Required';
      }

      if (!values.password) {
        errors.password = 'Required';
      }

      return errors;
    },
    onSubmit: handleSubmit
  }, function (_ref6) {
    var isValid = _ref6.isValid;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "email"
    }, "Email address"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "email",
      name: "email",
      type: "email",
      placeholder: "Email address..."
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "password"
    }, "Password"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "password",
      name: "password",
      type: "password",
      placeholder: "Password..."
    }), /*#__PURE__*/React.createElement("button", {
      style: loading || !isValid ? {
        opacity: '.5'
      } : {},
      type: "submit"
    }, buttonText));
  });
};

var SignUp = function SignUp(_ref7) {
  var setMessage = _ref7.setMessage,
      handleMessageSubmit = _ref7.handleMessageSubmit,
      formValues = _ref7.formValues,
      organizationId = _ref7.organizationId,
      apiHost = _ref7.apiHost,
      buttonText = _ref7.buttonText,
      onSignUp = _ref7.onSignUp;

  var _useUser2 = useUser(),
      setUser = _useUser2.setUser;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(values) {
      var gravatar, avatar, _yield$post3, error, data;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              gravatar = getGravatar.url(values.email);
              _context3.next = 3;
              return fetch("https:" + gravatar + "?d=404").then(function (res) {
                return res.ok && "https:" + gravatar || '';
              });

            case 3:
              avatar = _context3.sent;
              _context3.next = 6;
              return post(apiHost, '/api/register', {
                email: values.email,
                password: values.password,
                firstName: values.first_name,
                lastName: values.last_name,
                avatar: avatar,
                organizationId: organizationId
              });

            case 6:
              _yield$post3 = _context3.sent;
              error = _yield$post3.error;
              data = _yield$post3.data;
              _context3.next = 11;
              return handleMessageSubmit(formValues || {
                email: values.email
              });

            case 11:
              onSignUp && onSignUp({
                email: values.email,
                firstName: values.first_name,
                lastName: values.last_name
              });
              setUser({
                id: data.userId
              });

              if (error) {
                setMessage(error.message);
              }

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(Formik, {
    validateOnMount: true,
    initialValues: {
      email: '',
      password: '',
      first_name: '',
      last_name: ''
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.first_name) {
        errors.first_name = 'Required';
      }

      if (!values.email) {
        errors.email = 'Required';
      }

      if (!values.password) {
        errors.password = 'Required';
      }

      return errors;
    },
    onSubmit: handleSubmit
  }, function (_ref9) {
    var isValid = _ref9.isValid,
        isSubmitting = _ref9.isSubmitting;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", {
      className: "squeak-authentication-form-name"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "first_name"
    }, "First name"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "first_name",
      name: "first_name",
      type: "text",
      placeholder: "First name..."
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "last_name"
    }, "Last name"), /*#__PURE__*/React.createElement(Field, {
      id: "last_name",
      name: "last_name",
      type: "text",
      placeholder: "Last name..."
    }))), /*#__PURE__*/React.createElement("label", {
      htmlFor: "email"
    }, "Email address"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "email",
      name: "email",
      type: "email",
      placeholder: "Email address..."
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "password"
    }, "Password"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "password",
      name: "password",
      type: "password",
      placeholder: "Password..."
    }), /*#__PURE__*/React.createElement("button", {
      style: isSubmitting || !isValid ? {
        opacity: '.5'
      } : {},
      type: "submit"
    }, buttonText));
  });
};

var ResetPassword = function ResetPassword(_ref10) {
  var setMessage = _ref10.setMessage,
      setParentView = _ref10.setParentView,
      apiHost = _ref10.apiHost;

  var _useState4 = useState(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var resetPassword = useRef();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(values) {
      var _yield$post4, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setLoading(true);
              _context4.next = 3;
              return post(apiHost, '/api/password/reset', {
                password: values.password
              });

            case 3:
              _yield$post4 = _context4.sent;
              error = _yield$post4.error;

              if (error) {
                setMessage(error.message);
              } else {
                setParentView(null);
              }

              setLoading(false);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x4) {
      return _ref11.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (resetPassword === null || resetPassword === void 0 ? void 0 : resetPassword.current) {
      resetPassword.current.scrollIntoView();
    }
  }, [resetPassword]);
  return /*#__PURE__*/React.createElement("div", {
    ref: resetPassword
  }, /*#__PURE__*/React.createElement(Formik, {
    validateOnMount: true,
    initialValues: {
      password: ''
    },
    validate: function validate(values) {
      var errors = {};

      if (!values.password) {
        errors.password = 'Required';
      }

      return errors;
    },
    onSubmit: handleSubmit
  }, function (_ref12) {
    var isValid = _ref12.isValid;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "password"
    }, "New password"), /*#__PURE__*/React.createElement(Field, {
      required: true,
      id: "password",
      name: "password",
      type: "password",
      placeholder: "New password"
    }), /*#__PURE__*/React.createElement("button", {
      style: loading || !isValid ? {
        opacity: '.5'
      } : {},
      type: "submit"
    }, "Reset password"));
  }));
};

export default function Authentication(_ref13) {
  var handleMessageSubmit = _ref13.handleMessageSubmit,
      formValues = _ref13.formValues,
      setParentView = _ref13.setParentView,
      _ref13$initialView = _ref13.initialView,
      initialView = _ref13$initialView === void 0 ? 'sign-in' : _ref13$initialView,
      _ref13$buttonText = _ref13.buttonText,
      buttonText = _ref13$buttonText === void 0 ? {
    login: 'Login',
    signUp: 'Sign up'
  } : _ref13$buttonText,
      banner = _ref13.banner,
      onSignUp = _ref13.onSignUp;

  var _useOrg2 = useOrg(),
      organizationId = _useOrg2.organizationId,
      apiHost = _useOrg2.apiHost;

  var _useState5 = useState(initialView),
      view = _useState5[0],
      setView = _useState5[1];

  var _useState6 = useState(null),
      message = _useState6[0],
      setMessage = _useState6[1];

  var handleForgotPassword = function handleForgotPassword(e) {
    e.preventDefault();
    setView('forgot-password');
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Avatar, null), formValues && /*#__PURE__*/React.createElement("div", {
    className: "squeak-post-preview-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "squeak-post-preview"
  }, (formValues === null || formValues === void 0 ? void 0 : formValues.subject) && /*#__PURE__*/React.createElement("h3", null, formValues.subject), formValues.question), /*#__PURE__*/React.createElement("div", {
    className: "squeak-button-container"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setParentView('question-form');
    }
  }, "Edit post"))), /*#__PURE__*/React.createElement("div", {
    className: "squeak-authentication-form-container"
  }, banner && /*#__PURE__*/React.createElement("div", {
    className: "squeak-authentication-form-message"
  }, /*#__PURE__*/React.createElement("h4", null, banner.title), /*#__PURE__*/React.createElement("p", null, banner.body)), /*#__PURE__*/React.createElement("div", {
    className: "squeak-authentication-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "squeak-authentication-navigation"
  }, /*#__PURE__*/React.createElement("button", {
    className: view === 'sign-in' ? 'active' : '',
    onClick: function onClick() {
      return setView('sign-in');
    }
  }, "Login"), /*#__PURE__*/React.createElement("button", {
    className: view === 'sign-up' ? 'active' : '',
    onClick: function onClick() {
      return setView('sign-up');
    }
  }, "Signup"), /*#__PURE__*/React.createElement("div", {
    style: {
      opacity: view === 'forgot-password' || view === 'reset-password' ? 0 : 1
    },
    className: "squeak-authentication-navigation-rail " + view
  })), /*#__PURE__*/React.createElement("div", {
    className: "squeak-authentication-form-wrapper"
  }, message && /*#__PURE__*/React.createElement("p", {
    className: "squeak-auth-error"
  }, message), {
    'sign-in': /*#__PURE__*/React.createElement(SignIn, {
      buttonText: buttonText.login,
      formValues: formValues,
      handleMessageSubmit: handleMessageSubmit,
      setMessage: setMessage,
      apiHost: apiHost,
      organizationId: organizationId
    }),
    'sign-up': /*#__PURE__*/React.createElement(SignUp, {
      buttonText: buttonText.signUp,
      formValues: formValues,
      handleMessageSubmit: handleMessageSubmit,
      setMessage: setMessage,
      organizationId: organizationId,
      apiHost: apiHost,
      onSignUp: onSignUp
    }),
    'forgot-password': /*#__PURE__*/React.createElement(ForgotPassword, {
      setParentView: setParentView,
      setMessage: setMessage,
      apiHost: apiHost
    }),
    'reset-password': /*#__PURE__*/React.createElement(ResetPassword, {
      setParentView: setParentView,
      setMessage: setMessage,
      apiHost: apiHost
    })
  }[view], view !== 'forgot-password' && view !== 'reset-password' && /*#__PURE__*/React.createElement("button", {
    onClick: handleForgotPassword,
    className: "squeak-forgot-password"
  }, "Forgot password")))));
}